function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import get from 'lodash/get';
import { Box, Flex, chakra as C } from '@tapresearch/ui/components';
import Loading from 'Shared/Loading';
import CampaignSurveyResultQuestionItem from '../../../campaign/CampaignSurveyResultQuestionItem';
export var ResultsView = function(param) {
    var results = param.results, tapSurveyIdentifier = param.tapSurveyIdentifier, completesCount = param.completesCount, resultsLoading = param.resultsLoading;
    var questionsHash = get(results, 'questions', {});
    var tapQuestions = Object.keys(questionsHash).filter(function(key) {
        return key.includes('tq');
    }).map(function(question_id) {
        return _object_spread_props(_object_spread({}, questionsHash[question_id]), {
            id: question_id
        });
    });
    if (resultsLoading) {
        return /*#__PURE__*/ React.createElement(Flex, _object_spread({
            align: "center",
            justify: "center"
        }, Styles.Panel), /*#__PURE__*/ React.createElement(Loading, null));
    }
    return /*#__PURE__*/ React.createElement(Box, null, completesCount > 0 ? tapQuestions.map(function(question, questionIndex) {
        return /*#__PURE__*/ React.createElement(CampaignSurveyResultQuestionItem, {
            key: question.id,
            questionsHash: questionsHash,
            question: question,
            position: questionIndex + 1,
            resultsIdentifier: tapSurveyIdentifier,
            isCampaignResults: false
        });
    }) : /*#__PURE__*/ React.createElement(Flex, Styles.Panel, /*#__PURE__*/ React.createElement(C.h3, {
        fontWeight: 'medium',
        fontSize: 'xl',
        color: 'gray.400'
    }, "No responses gathered yet.")));
};
var Styles = {
    Panel: {
        borderRadius: '8px',
        bg: 'white',
        m: '30px 0',
        p: '50px',
        textAlign: 'center',
        boxShadow: '#e1e2e5 0 0 21px -3px',
        minHeight: '300px',
        justify: 'center',
        align: 'center'
    }
};
